import { render, staticRenderFns } from "./editor.vue?vue&type=template&id=12bac18d&scoped=true"
import script from "./editor.vue?vue&type=script&lang=ts"
export * from "./editor.vue?vue&type=script&lang=ts"
import style0 from "./editor.vue?vue&type=style&index=0&id=12bac18d&prod&scoped=true&lang=css"
import style1 from "@/styles/editor.scss?vue&type=style&index=1&id=12bac18d&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bac18d",
  null
  
)

export default component.exports